











































import CallApp from 'callapp-lib';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {State, Getter, Action, Mutation} from 'vuex-class';
import appSdk from '../../sdk/sdk';
import wx from 'weixin-js-sdk';

@Component({
  components: {},
})
export default class Header extends Vue {
  @Prop()
  private routers!: any;
  @Action('getWXConfigSign')
  private getWXConfigSign!: any;

  private isAPP: boolean = false; // 是否在APP内
  private isWeixinTip: boolean = false;
  private isWeixin: boolean = false;
  private isWeibo: boolean = false;
  private isQQZone: boolean = false;
  private isCloseDownload: boolean = false; // 是否关闭了下载app的提示
  private hostContextTest: any[] = ['https://app-test.nio.com', 'https://app-test.nio.com/pe/onekeyhelp'];
  private hostContextStg: any[] = ['https://app-stg.nio.com', 'https://app-stg.nio.com/pe/onekeyhelp'];
  private hostContext: any[] = ['https://app.nio.com', 'https://app.nio.com/pe/onekeyhelp'];

  private shareParams: any = {
    title: '一键加电全介绍',
    description: '详细了解一键加电背后的服务流程、操作指南及能量无忧套餐',
    image: this.hostContext[1] + '/static/onekeyhelp.png',
    url: window.location.href,
  };

  private isInApp() {
    return navigator.userAgent.toLowerCase().indexOf('nio-lifestyle') !== -1;
  }

  private isInWeixin() {
    return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
  }

  private isInWeibo() {
    return navigator.userAgent.toLowerCase().indexOf('weibo') !== -1;
  }

  private isInQQZone() {
    return navigator.userAgent.toLowerCase().indexOf('qq') !== -1;
  }

  private goBack() {
    this.$router.go(-1);
  }

  private goBackApp() {
    const params = {method: 'peAppDoBack', params: {}, callback: {}};
    appSdk.callAPP(params);
  }

  private toShare() {
    const path = window.location.href;
    let baseUrl = this.hostContext[1]

    if (path.match(/app-test/i)) {
      baseUrl = this.hostContextTest[1]
    } else if (path.match(/app-stg/i)) {
      baseUrl = this.hostContextStg[1]
    }
    const params = {
      method: 'peAppDoH5Share',
      params: {
        title: this.shareParams.title,
        description: this.shareParams.description,
        image: this.shareParams.image,
        url: baseUrl + '/static/index.html?isloadjsbridge=1&isshownav=0',
      },
      callback: {},
    };
    appSdk.callAPP(params);
  }

  private callAndroidApp() {
    const h5url = this.hostContext[1] + '/static/index.html&isloadjsbridge=1&isshownav=0&webviewtitle=';
    const url = 'nio://peservice/peh5webview?url=' + h5url;
    const path = 'thirdapp';
    const params = {
      param: {
        redirect: encodeURIComponent(url),
      },
      path,
    };
    const options = {
      scheme: {
        protocol: 'nio',
      },
      intent: {
        package: 'cn.com.weilaihui3',
        category: 'android.intent.category.DEFAULT',
        action: 'android.intent.action.VIEW',
        scheme: 'nio',
      },
      fallback: 'https://app-dl.nio.com',
    };
    const callLib = new CallApp(options);
    callLib.open(params);
  }

  private callIOSApp() {
    const h5url = this.hostContext[1] + '/static/index.html&isloadjsbridge=1&isshownav=0&webviewtitle=';
    const path = 'peservice/peh5webview';
    const params = {
      param: {
        url: h5url,
      },
      path,
    };
    const options = {
      scheme: {
        protocol: 'nio',
      },
      fallback: 'https://app-dl.nio.com',
    };
    const callLib = new CallApp(options);
    callLib.open(params);
  }

  private callApp() {
    const ua = navigator.userAgent;
    const isAndroid = !!ua.match(/android/ig);
    if (isAndroid) {
      this.callAndroidApp();
    } else {
      this.callIOSApp();
    }
  }

  private openApp() {
    if (this.isWeixin || this.isWeibo || this.isQQZone) {
      this.isWeixinTip = true;
    } else {
      this.isWeixinTip = false;
      this.isCloseDownload = true;
      this.callApp();
    }
  }

  private closeDownload() {
    this.isCloseDownload = true;
  }

  private async created() {
    this.isAPP = this.isInApp();
    this.isWeixin = this.isInWeixin();
    this.isWeibo = this.isInWeibo();
    this.isQQZone = this.isInQQZone();
    this.isCloseDownload = this.isAPP;
    await this.WXShare();
  }


  private async WXShare() {
    // 请求接口获取微信签名
    if (this.isWeixin) {
      const signParams: any = {
        baseUrl: this.hostContext[0],
        signUrl: this.shareParams.url,
      };
      const jsApiList = [
        'onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone',
      ];
      const wxShareParams = {
        title: this.shareParams.title, // 分享标题
        desc: this.shareParams.description, // 分享描述
        link: this.shareParams.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.shareParams.image, // 分享图标
      };
      const data = await this.getWXConfigSign(signParams);
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
        appId: data.app_id, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonce_str, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList,
      });
      wx.ready(() => {
        wx.checkJsApi({
          jsApiList,
        });
        // 分享到朋友圈
        wx.onMenuShareTimeline(wxShareParams);

        // 分享给朋友
        wx.onMenuShareAppMessage(wxShareParams);

        // 分享到QQ
        wx.onMenuShareQQ(wxShareParams);

        // 分享到腾讯微博
        wx.onMenuShareWeibo(wxShareParams);

        // 分享到QQ空间
        wx.onMenuShareQZone(wxShareParams);
      });
    }
  }


}

